import '@mui/material/styles/styled';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client/react';
import App from './App.jsx';
import './index.css';
import global_en from './components/atoms/texts/en/global.json';
import global_fr from './components/atoms/texts/fr/global.json';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from '@mui/material/styles';
import theme from './components/atoms/colors/theme';
import TraceProvider from '@/lib/tracing.jsx';
import moment from 'moment';
import 'moment/locale/fr';
import { QueryClientProvider } from '@tanstack/react-query';
import client from './services/apolloClient.js';
import { onSigninCallback, queryClient, userManager } from './components/authentication/keycloak.js';
import { AuthProvider } from 'react-oidc-context';
import { ProtectedApp } from '@/components/authentication/ProtectedApp.jsx';
import { Provider } from 'react-redux';
import store from '@/store/store.js';
import { CookieCompatibilityProvider } from './context/CookieCompatibilityContext.jsx';
import { TooltipProvider } from '@/components/ui/tooltip';


i18next.init({
    interpolation: {
        escapeValue: false,
        format: function (value, format, lng) {
            if (value instanceof Date) {
                return moment(value).locale(lng).format(format);
            }
            return value;
        }
    },
    lng: 'en',
    resources: {
        en: {
            global: global_en,
            label: 'English'
        },
        fr: {
            global: global_fr,
            label: 'Français'
        }
    }
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Provider store={store}>
            <I18nextProvider i18n={i18next}>
                <CookieCompatibilityProvider>
                    <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
                        <QueryClientProvider client={queryClient}>
                            <ProtectedApp>
                                <ApolloProvider client={client}>
                                    <ThemeProvider theme={theme}>
                                        <TooltipProvider>
                                            <TraceProvider>
                                                <App />
                                            </TraceProvider>
                                        </TooltipProvider>
                                    </ThemeProvider>
                                </ApolloProvider>
                            </ProtectedApp>
                        </QueryClientProvider>
                    </AuthProvider>
                </CookieCompatibilityProvider>
            </I18nextProvider>

        </Provider>
    </React.StrictMode>
);
